import { Chip } from '@material-ui/core'

import { TableRow, TableCell } from 'components/Table'
import { MenuButton, Permitted } from 'components'

import ActionButtons from '../ActionButtons'

import constants from 'constants/index'
import helpers from 'helpers'

import PropTypes from 'prop-types'

const ChurnsTableRow = ({ churn, refresh, setIsLoading }) => {
  return (
    <>
      <TableRow key={churn?.id}>
        <TableCell>{churn?.id}</TableCell>
        <TableCell>{churn?.preRegistration?.name}</TableCell>
        <TableCell>{churn?.contractIdentifier}</TableCell>
        <TableCell>
          {helpers.formatters.cnpjAndCpfMask(churn?.preRegistration?.document)}
        </TableCell>
        <TableCell>{constants.churn.ORIGINS[churn?.origin]}</TableCell>
        <TableCell align="center">
          {churn?.ticketId ? churn?.ticketId : '-'}
        </TableCell>
        <TableCell align="center">
          {churn?.ticketDate ? helpers.formatters.date(churn?.ticketDate) : '-'}
        </TableCell>
        <TableCell align="center">
          {helpers.churns.author(churn, true)}
        </TableCell>
        <TableCell align="center" disableTooltip>
          <Chip
            align="center"
            size="small"
            label={constants.churn.STATUS_LABEL_TRANSLATION[churn?.status]}
            style={{
              backgroundColor: constants.churn.CHIP_STATUS_COLOR[churn?.status],
              color: '#FFFFFF',
            }}
          />
        </TableCell>
        <TableCell align="center" disableTooltip>
          <Permitted
            someTags={[
              constants.permissions.CHURNS.MANAGE,
              constants.permissions.CHURNS.SHOW,
            ]}
          >
            <MenuButton>
              <ActionButtons
                churn={churn}
                refresh={refresh}
                setIsLoading={setIsLoading}
              />
            </MenuButton>
          </Permitted>
        </TableCell>
      </TableRow>
    </>
  )
}

ChurnsTableRow.propTypes = {
  churn: PropTypes.object,
  refresh: PropTypes.func,
  setIsLoading: PropTypes.func,
}

export default ChurnsTableRow
